import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Nanum Gothic', sans-serif;
    }

    a {
        color: #000;
        text-decoration: none;
        outline: none
    }

    a:hover, a:active {
        text-decoration: none;
        color: #000;
    }

    // MUI datagrid 셀렉션 제거
    .MuiDataGrid-cell:focus,
    .MuiDataGrid-cell:active,
    .MuiDataGrid-cell:focus-within {
        outline: none !important;
    }

    .MuiDataGrid-row {
        cursor: pointer
    }

    .MuiTextField-root {
        margin-bottom: -3px;
    }

    .MuiAccordion-root {
        border: 1px solid #eee;
    }

    .MuiDataGrid-virtualScroller {
        overflow: hidden;
    }

    // Sweet Alert Toast color
    .swal2-container {
        z-index: 2001 !important;
        min-width: 360px;
        max-width: 100%;
        width: auto !important;
        white-space: pre-wrap !important;
    }


    .colored-toast.swal2-icon-error {
        background-color: #FF4245 !important;
    }

    .colored-toast.swal2-icon-success {
        background-color: #3BBA39 !important;
    }

    .colored-toast.swal2-icon-warning {
        background-color: #FFB626 !important;
    }

    .colored-toast.swal2-icon-info {
        background-color: #53B0FC !important;
    }

    .colored-toast .swal2-title {
        font-size: 1.3rem !important;
        font-weight: bold !important;
        color: white;
    }

    .colored-toast .swal2-close {
        color: white;
    }

    .colored-toast .swal2-html-container {
        color: white;
        font-size: 1.1rem !important;
    }

    .custom-sweet-alert-text-font {
        font-size: 1rem !important;
        font-weight: bold;
    }

    .custom-sweet-alert-button-font {
        font-size: 1rem !important;
    }
`;

export default GlobalStyle;
